import React from 'react';
import Product from './Product';
import { Droppable } from 'react-beautiful-dnd';
import styled from 'styled-components';

const Wrapper = styled.div`
	border: 1px solid lightgrey;
	padding: 16px;
	width: 47%;
	font-family: 'Roboto';
	border-radius: 4px;
	background-color: white;
`;

const Title = styled.div`
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 10px;
`;

const Container = styled.div`
	padding: 16px;
	background-color: #e7ebef;
	border-radius: 4px;
	max-height: 400px;
	height: 400px;
	overflow: auto;
`;

const NoProductContainer = styled.div``;

const ProductContainer = ({ 
	index, 
	title, 
	products,
}) => {
	return (
		<Wrapper>
			<Title>{title}</Title>
			<Droppable droppableId={`${index}`} >
				{(provided) => (
						<Container {...provided.droppableProps} ref={provided.innerRef}>
							{!products ||
								(products.length <= 0 && (
									<NoProductContainer>No Products</NoProductContainer>
								))}
							{products &&
								products.length > 0 &&
								products.map((product, _index) => {
									return <Product product={product} index={_index} key={product.id} />;
								})}
							{provided.placeholder}
						</Container>
				)}
			</Droppable>
		</Wrapper>
	);
};

export default ProductContainer;
